import React, { useState } from "react";
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
    Input
} from "reactstrap";
import Papa from "papaparse";
import { importProsprEmployee } from "helpers/fakebackend_helper";

const ImportProsprEmployeeReportModal = ({ isOpen, toggle }) => {
    const user = JSON.parse(localStorage.getItem("authUser"));
    const [file, setFile] = useState(null);
    const [parsedData, setParsedData] = useState([]);
    const [isCorrectFormat, setIsCorrectFormat] = useState(null);
    const [loading, setLoading] = useState(false);

    const requiredColumns = [
        "Date",
        "Name",
        "Location",
        "Scheduled Start",
        "Actual Start",
        "Scheduled End",
        "Actual End",
        "Base Hrs",
        "Hrs w/ Breaks",
        "Rate",
        "Labor Cost",
        "Employee ID",
        "Breaks (#)",
        "Rate Type",
        "DT (hrs)",
        "OT (hrs)",
        "RT (hrs)",
        "Time Off Type",
        "Clock Out - GeoFence",
        "Clock In - GeoFence",
        "ClockOut Distance",
        "ClockIn Distance",
        "Breaks (mins)",
        "End Type",
        "Team",
        "Last Name",
        "First Name",
        "Sched Base hrs",
    ];

    const handleFileChange = (e) => {
        const uploadedFile = e.target.files[0];
        setFile(uploadedFile);

        Papa.parse(uploadedFile, {
            header: true,
            skipEmptyLines: true,
            complete: function (results) {
                setParsedData(results.data);
                console.log("result_data: ", results.data)

                const parsedColumns = results.meta.fields || [];

                const missingColumns = requiredColumns.filter(
                    col => !parsedColumns.includes(col)
                );
                const extraColumns = parsedColumns.filter(
                    col => !requiredColumns.includes(col)
                );

                const hasAllRequired =
                    requiredColumns.every(col => parsedColumns.includes(col)) &&
                    parsedColumns.every(col => requiredColumns.includes(col));

                setIsCorrectFormat(hasAllRequired ? 1 : 0);

                if (!hasAllRequired) {
                    console.log(`❌ Format mismatch.\n\nMissing: ${missingColumns.join(", ") || "None"}\nExtra: ${extraColumns.join(", ") || "None"}`)
                }
            }
        });
    };

    const importData = async () => {
        try {
            setLoading(true);
            await importProsprEmployee(user.token, parsedData);
        } catch (error) {
            console.error("Import failed:", error);
        } finally {
            toggle()
            setLoading(false);
        }
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle} centered>
            <ModalHeader toggle={toggle}>Import Prospr Employee Report</ModalHeader>
            <ModalBody>
                <Input type="file" onChange={handleFileChange} accept=".csv" />

                {file && (
                    <div className="mt-3">
                        <h6>File Information</h6>
                        <p className="mb-1">
                            <strong>Name:</strong> {file.name}
                        </p>
                        <p className="mb-1">
                            <strong>Size:</strong>{" "}
                            {(file.size / 1024 / 1024).toFixed(2)} MB
                        </p>
                        <p className="mb-1">
                            <strong>Type:</strong> {file.type || "N/A"}
                        </p>
                        <p className="mb-1">
                            <strong>Correct Format?:</strong>
                            {isCorrectFormat === 1 ? (
                                <span
                                    className="badge bg-success"
                                    style={{
                                        fontWeight: "bold",
                                        fontSize: 10,
                                        padding: 5,
                                        color: "#FFFFFF",
                                        marginLeft: 10
                                    }}
                                >
                                    YES
                                </span>
                            ) : isCorrectFormat === 0 ? (
                                <span
                                    className="badge bg-danger"
                                    style={{
                                        fontWeight: "bold",
                                        fontSize: 10,
                                        padding: 5,
                                        color: "#FFFFFF",
                                        marginLeft: 10
                                    }}
                                >
                                    NO, CONTACT DEVELOPER
                                </span>
                            ) : null}
                        </p>
                        {parsedData.length > 0 && (
                            <>
                                <h6><strong>Potential Problems (RT {'>'} 18):</strong></h6>
                                <div style={{ overflowX: "auto", maxHeight: "300px" }}>
                                    <table className="table table-bordered table-sm">
                                        <thead>
                                            <tr>
                                                {Object.keys(parsedData[0]).map((col, idx) => (
                                                    <th key={idx}>{col}</th>
                                                ))}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {parsedData
                                                .filter(row => parseFloat(row["RT (hrs)"] || 0) > 18)
                                                .map((row, i) => (
                                                    <tr key={i}>
                                                        {Object.keys(row).map((col, j) => (
                                                            <td key={j}>{row[col]}</td>
                                                        ))}
                                                    </tr>
                                                ))}
                                        </tbody>
                                    </table>
                                </div>
                            </>
                        )}
                    </div>
                )}
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={toggle}>
                    Close
                </Button>
                {isCorrectFormat === 1 && (
                    <Button
                        color="primary"
                        onClick={importData}
                        disabled={loading}
                    >
                        {loading ? "Importing..." : "Import Data"}
                    </Button>
                )}
            </ModalFooter>
        </Modal>
    );
};

export default ImportProsprEmployeeReportModal;